import { type CountryCode } from '@resurs-internal/mui/assets/countries';
import { isDevelopment } from 'helpers/environmentUtils';

import { type DepositProduct } from '@/types/consumer-deposit-application-service';
const productUrl = `${import.meta.env.VITE_RESURS_EKS_HOST}/api/consumer_deposit_application_service/products`;

export const fetchProducts = async (
  country: CountryCode,
): Promise<DepositProduct[]> => get(country);

export const get = async (country: CountryCode): Promise<DepositProduct[]> => {
  const headers: { [key: string]: string } = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  if (!isDevelopment) headers.apikey = import.meta.env.VITE_RESURS_API_KEY;
  const searchParams = new URLSearchParams({ country });

  return fetch(`${productUrl}?${searchParams.toString()}`, {
    headers,
    method: 'GET',
  }).then(async (response) => {
    if (response.status !== 200) {
      throw Error(
        `Could not fetch products ${JSON.stringify(await response.json())}`,
      );
    }

    return response.json().then((json: DepositProduct[]) => json);
  });
};
